<template lang="pug">
div
  swiper(ref="sw" :options="swiperOptions" @slideChange="handleSlideChange")
    swiper-slide.match-marketgroup-content(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
      .match-bet-area-group.flex-grow-2
        hdpItem(:details="details" :oddsType="oddsType" betType="hdp" homeAway="1")
      .match-bet-area-group.flex-grow-2
        ouItem(:details="details" :oddsType="oddsType" betType="ou")
      .match-bet-area-group.flex-grow-1
        oeItem(:details="details" :oddsType="oddsType" betType="oe")
    template(v-if="source.details.hdph || source.details.ouh || source.details.oeh")
      swiper-slide.match-marketgroup-content(:class="[(source.marketId == 3) ? 'live' : '', leagueKindClassOf(source.leagueId)]")
        template(v-if="activeIndex == 1")
          .match-bet-area-group.flex-grow-2
            hdpItem(:details="details" :oddsType="oddsType" betType="hdph" homeAway="2")
          .match-bet-area-group.flex-grow-2
            ouItem(:details="details" :oddsType="oddsType" betType="ouh")
          .match-bet-area-group.flex-grow-1
            oeItem(:details="details" :oddsType="oddsType" betType="oeh")
    .swiper-pagination(slot="pagination")
</template>

<script>
import hdpItem from "@/components/mobile/main/xitem/hdpItem";
import ouItem from "@/components/mobile/main/xitem/ouItem";
import oeItem from "@/components/mobile/main/xitem/oeItem";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    hdpItem,
    ouItem,
    oeItem
  },
  mixins: [mixinHDPOUOdds],
  data() {
    return {
      activeIndex: 0,
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.sw ? this.$refs.sw.$swiper : 0;
    }
  },
  mounted() {
    this.activeIndex = this.swiper.activeIndex;
  },
  methods: {
    handleSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
    }
  }
};
</script>